import axios from "axios"
import baseURL from "../configs/api"

export const calculate = (data: any, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/Calculate`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const confirmBooking = (data: any, status: string, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/ConfirmBooking`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            status,
            userId
        }
    }).then(response => response.data);
}

export const dateChange = (data: any, id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/DateChange`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            id,
            userId
        }
    }).then(response => response.data);
}

export const securityDepositManuallyChange = (securityDepositAmount: number, id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/SecurityDepositManuallyChange`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        params: {
            securityDepositAmount,
            id,
            userId
        }
    }).then(response => response.data);
}

export const cancelReservation = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/CancelReservation`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {           
            userId
        }
    }).then(response => response.data);
}

export const openReservation = (id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/OpenReservation`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,      
        params: {     
            id,      
            userId
        }
    }).then(response => response.data);
}

export const vehicleClassChange = (id: number, vehicleClassId: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/vehicleClassChange`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        params: {
            id,
            vehicleClassId,
            userId
        }
    }).then(response => response.data);
}

export const addAdditionalChargeApi = (id: number, additionalChargeBranchId: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/AddAdditionalCharge`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        params: {
            id,
            additionalChargeBranchId,
            userId
        }
    }).then(response => response.data);
}

export const addNewAdditionalCharge = (id: number, additionalChargeBranchId: number, additionalChargeId: number, amountOrPercentage: number, comment: string, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/AddNewAdditionalCharge`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        params: {
            id,
            additionalChargeBranchId,
            additionalChargeId,
            amountOrPercentage,
            comment,
            userId
        }
    }).then(response => response.data);
}

export const editNewAdditionalCharge = (id: number, reservationAdditionalChargeId: number, additionalChargeId: number, amountOrPercentage: number, commentId: number, comment: string, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/EditNewAdditionalCharge`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        params: {
            id,
            reservationAdditionalChargeId,
            additionalChargeId,
            amountOrPercentage,
            commentId,
            comment,
            userId
        }
    }).then(response => response.data);
}

export const deleteAdditionalChargeApi = (id: number, reservationAdditionalChargeId: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/DeleteAdditionalCharge`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        params: {
            id,
            reservationAdditionalChargeId,
            userId
        }
    }).then(response => response.data);
}

export const updateOrderApi = (data: any, id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/UpdateOrder`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            id,
            userId
        }
    }).then(response => response.data);
}

export const updateDiscount = (data: any, id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/UpdateDiscount`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            id,
            userId
        }
    }).then(response => response.data);
}

export const driverChange = (id: number, customerId: number, isPrimaryDriver: boolean, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/DriverChange`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        params: {
            id,
            customerId,
            isPrimaryDriver,
            userId
        }
    }).then(response => response.data);
}

export const driverChangeFromExistingDriver = (id: number, reservationAdditionalDiverId: number, customerId: number, isPrimaryDriver: boolean, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/DriverChangeFromExistingDriver`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        params: {
            id,
            reservationAdditionalDiverId,
            customerId,
            isPrimaryDriver,
            userId
        }
    }).then(response => response.data);
}

export const updateStatus = (id: number, status: string, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/UpdateStatus`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        params: {
            id,
            status,
            userId
        }
    }).then(response => response.data);
}

export const freeVehicleChange = (id: number, vehicleClassId: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/FreeVehicleChange`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        params: {
            id,
            vehicleClassId,
            userId
        }
    }).then(response => response.data);
}

export const checkoutVehicle = (data: any, id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/CheckoutVehicle`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            id,
            userId
        }
    }).then(response => response.data);
}


export const updatePickupInfo = (data: any, id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/UpdatePickupInfo`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            id,
            userId
        }
    }).then(response => response.data);
}

export const cancelPickup = (id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/CancelPickup`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        params: {
            id,
            userId
        }
    }).then(response => response.data);
}

export const confirmAgreement = (data: any, id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/ConfirmAgreement`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            id,
            userId
        }
    }).then(response => response.data);
}

export const disableRenewal = (id: number, isDisableRenewal: boolean, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/DisableRenewal`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        params: {
            id,
            isDisableRenewal,
            userId
        }
    }).then(response => response.data);
}

export const addEarlyReturn = (data: any, isRecalculateRateOnEarlyReturn: boolean, id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/AddEarlyReturn`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            isRecalculateRateOnEarlyReturn,
            id,
            userId
        }
    }).then(response => response.data);
}

export const addExtension = (data: any, id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/AddExtension`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            id,
            userId
        }
    }).then(response => response.data);
}

export const replacedVehicle = (data: any, id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/ReplacedVehicle`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            id,
            userId
        }
    }).then(response => response.data);
}

export const updateReturnLocation = (returnLocationId: number, id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/UpdateReturnLocation`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        params: {
            returnLocationId,
            id,
            userId
        }
    }).then(response => response.data);
}

export const isReOpen = (id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/IsReOpen`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        params: {
            id,
            userId
        }
    }).then(response => response.data);
}

export const checkinVehicle = (data: any, id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/CheckinVehicle`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            id,
            userId
        }
    }).then(response => response.data);
}

export const recalculateAtReturn = (data: any, id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/RecalculateAtReturn`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            id,
            userId
        }
    }).then(response => response.data);
}

export const donotValidateOutStandingBalance = (data: any, id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/DonotValidateOutStandingBalance`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            id,
            userId
        }
    }).then(response => response.data);
}

export const changeReservationDetails = (data: any, id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/ChangeReservationDetails`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            id,
            userId
        }
    }).then(response => response.data);
}

export const deleteRefund = (refundId: number, id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/DeleteRefund`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        params: {
            refundId,
            id,
            userId
        }
    }).then(response => response.data);
}

export const updateFilesAndCommentsApi = (data: any, id: number, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/UpdateFilesAndComments`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            id,
            userId
        }
    }).then(response => response.data);
}

export const getReservationSummary = (primaryKey: number, tenantId: string) => {
    return getFetch(`rentals/GetReservationSummary`, tenantId, { id: primaryKey });
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}